var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriceIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03481 2.95301L4.77896 7.55783C4.64758 8.03952 4.01967 8.15939 3.7201 7.75996L2.1001 5.59995H1.2001C0.868727 5.59995 0.600098 5.33133 0.600098 4.99995C0.600098 4.66858 0.868727 4.39995 1.2001 4.39995H2.1001C2.47781 4.39995 2.83347 4.57779 3.0601 4.87996L3.94403 6.05853L5.42124 0.642085C5.57934 0.0623705 6.39685 0.0491883 6.57356 0.623504L8.42295 6.63402L9.03089 4.81022C9.11256 4.56521 9.34184 4.39995 9.6001 4.39995H10.8001C11.1315 4.39995 11.4001 4.66858 11.4001 4.99995C11.4001 5.33133 11.1315 5.59995 10.8001 5.59995H10.0326L8.96931 8.78969C8.78472 9.34344 7.99829 9.3343 7.82663 8.77641L6.03481 2.95301Z",
    fill: "#A653F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceIco);
export default __webpack_public_path__ + "static/media/PriceIco.93af515c6020e2fd7d4f62eaa5555d55.svg";
export { ForwardRef as ReactComponent };